import React from 'react';
import SellingFastIcon from './SellingFastIcon';
import {
	Wrapper, Text,
} from './sellingFastStyles';

const SellingFast = () => {
	return (
		<Wrapper>
			<SellingFastIcon />
			<Text><span>Selling Fast!</span> - Only a few boxes left. Buy soon while supplies last.</Text>
		</Wrapper>
	); 
};

export default SellingFast;